/**
 * Internal dependencies
 */
export * from 'editor/settings';



// WEBPACK FOOTER //
// ./src/modules/editor/index.js